/**
 * Settings Feature Routes — Product Portal
 */
import type { RouteRecordRaw } from 'vue-router';

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    redirect: { name: 'settings-dashboard' },
  },
  {
    path: '/settings/dashboard',
    name: 'settings-dashboard',
    component: () => import('./views/SettingsDashboardView.vue'),
    meta: {
      title: 'Settings',
      breadcrumbs: [
        { label: 'Settings' },
      ],
      modulePermission: 'settings',
    },
  },
  {
    path: '/settings/roles-permissions',
    name: 'settings-roles-permissions',
    component: () => import('./views/RolesPermissionsView.vue'),
    meta: {
      title: 'Roles & Permissions',
      breadcrumbs: [
        { label: 'Settings', to: { name: 'settings-dashboard' } },
        { label: 'Roles & Permissions' },
      ],
      modulePermission: 'settings',
    },
  },
  {
    path: '/settings/idp-federation',
    name: 'settings-idp-federation',
    component: () => import('./views/IdpFederationView.vue'),
    meta: {
      title: 'IDP Configuration',
      breadcrumbs: [
        { label: 'Settings', to: { name: 'settings-dashboard' } },
        { label: 'IDP Configuration' },
      ],
      modulePermission: 'settings',
    },
  },
];
